import { store } from '@/decorators/store';
import { TransportRequest } from '@/entities/TransportRequest';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'RequestStore' })
export class TransportRequestStore extends AbstractEntityStore<TransportRequest> {
  protected entityIdKey = 'requestId';
}
